<template>
  <div class="actionNav">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ActionNav',
  mounted () {
    document.querySelector("#app").classList.add("--actionNav")
  },
  beforeDestroy () {
    document.querySelector("#app").classList.remove("--actionNav")
  }
}
</script>

<style lang="sass">
\:root
  --actionNav-color-background: var(--color-nav)
  --actionNav-color-onBackground: var(--color-onNav)
  --actionNav__continue-color-background: var(--color-primary)
  --actionNav__continue-color-onBackground: var(--color-onPrimary)
  --actionNav__back-color-background: var(--color-nav)
  --actionNav__back-color-onBackground: var(--color-onNav)
  --actionNav__temsCheck-color-border: var(--color-overlay-50)
  --actionNav__temsCheck-color-pulseAnimaton: var(--color-primary)
  --actionNav__temsCheck--active-color-background: var(--color-primary)
  --actionNav__temsCheck--active-color-onBackground: var(--color-onPrimary)
.actionNav
  position: fixed
  bottom: 0
  left: 0
  width: 100%
  height: 3.5rem
  z-index: 1000
  background-color: var(--actionNav-color-background)
  color: var(--actionNav-color-onBackground)
  padding: 0 1rem
  display: flex
  align-items: center
  border-top: 1px solid var(--color-overlay-10)
  justify-content: flex-end
  box-shadow: 0 5px 10px 5px var(--color-overlay-10)
  transition: all .2s ease
  .btn
    height: 2.5rem
    text-align: center
  &__back.btn
    background-color: var(--actionNav__back-color-background)
    color: var(--actionNav__back-color-onBackground)
    margin-right: auto
  &__continue.btn
    background-color: var(--actionNav__continue-color-background)
    color: var(--actionNav__continue-color-onBackground)
  &__terms
    display: flex
    align-items: center
    justify-content: flex-end
    position: absolute
    bottom: 3.5rem
    right: 0
    width: 100%
    background-color: var(--color-nav)
    color: var(--color-onNav)
    &Wrapper
      display: flex
      justify-content: flex-end
      width: 100%
      align-items: center
      margin: 0
      padding: 1rem
      font-size: var(--font-size-sm)
      background-color: var(--color-overlay-10)
    &Text
      flex: 1
      text-align: right
    &Input
      position: absolute
      opacity: 0
      height: 0
      width: 0
      z-index: -1
      pointer-events: none
      &:checked~.actionNav__termsWrapper
        .actionNav__termsCheck
          background-color: var(--actionNav__temsCheck--active-color-background)
          animation: none
          i
            opacity: 1
            color: var(--actionNav__temsCheck--active-color-onBackground)
            transform: scale(1)
    &Check
      height: 1.5rem
      width: 1.5rem
      min-width: 1.5rem
      background-color: var(--color-surface)
      display: flex
      border: 2px solid var(--actionNav__temsCheck-color-border)
      border-radius: var(--b-radius-sm)
      margin: 0
      align-items: center
      cursor: pointer
      justify-content: center
      transition: border .3s ease, background-color .3s ease
      animation: pulse 2s infinite
      i
        transition: opacity .3s ease, color .3s ease, transform 0.3s ease
        opacity: 0
        transform: scale(2)
    &Link
      position: relative
      z-index: 1000
      border-bottom: 1px dotted
      font-weight: bolder
      cursor: pointer
      &:hover
        border-bottom: 1px solid
    &Content
      display: flex
      align-items: flex-end
      flex-direction: column
      padding-right: 1rem
@-webkit-keyframes pulse
  0%
    -webkit-box-shadow: 0 0 0 0 var(--actionNav__temsCheck-color-pulseAnimaton)
  70%
      -webkit-box-shadow: 0 0 0 20px transparent
  100%
      -webkit-box-shadow: 0 0 0 0 transparent
.--summary-active
  .ActionNav
    transform: translateX(-290px)
@media (min-width: 768px)
  .actionNav
    &__terms
      background-color: transparent
      position: initial
      &Check
        height: 1.75rem
        width: 1.75rem
        min-width: 1.75rem
      &Wrapper
        background-color: transparent
      // &Input
  .--summary-active
    .ActionNav
      transform: none
@media (min-width: 1200px)
  .ActionNav
    z-index: 10000
</style>
